// extracted by mini-css-extract-plugin
export default {"timeExclude":"usage-guide-modal_timeExclude__EhE53","timeWarning":"usage-guide-modal_timeWarning__0M9K6","limitationWrapper":"usage-guide-modal_limitationWrapper__ukdFQ"};